import { useEffect } from 'react';
import { observer } from 'mobx-react';

interface Props {
    resetField(): void;
    dataTest?: string;
}

export const HiddenField = observer(({ resetField, dataTest }: Props) => {
    useEffect(() => {
        resetField();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            data-test={dataTest}
            data-testid={dataTest}
        />
    );
});
